// const prices = document.querySelectorAll('.t4s-product-price .t4s-badge-price')

// setTimeout(() => {
//   prices.forEach(price => {
//     price.style.display = 'inline-block'
//   })
// }, 1400)

// Push History on USF list
// if (location.search.includes('usf_')) {
//   sessionStorage.setItem('lastFilteredURL', location.href)
//   sessionStorage.setItem('cameFromFiltered', 'true')
// } else {
//   sessionStorage.removeItem('cameFromFiltered')
// }

// window.addEventListener('DOMContentLoaded', () => {
//   const lastFiltered = sessionStorage.getItem('lastFilteredURL')
//   const cameFromFiltered = sessionStorage.getItem('cameFromFiltered')

//   if (!lastFiltered) return

//   if (cameFromFiltered === 'true') {
//     history.replaceState({ skipBackFix: true }, '')

//     window.addEventListener('popstate', e => {
//       if (!e.state || !e.state.skipBackFix) {
//         sessionStorage.removeItem('cameFromFiltered')
//         window.location.replace(lastFiltered)
//       }
//     })
//   }
// })
// Push History on USF list END



document.addEventListener('DOMContentLoaded', () => {
  document.addEventListener('click', e => {
    const el = e.target.closest('[data-on-skrr-click]')
    if (!el) return

    const elId = el.getAttribute('data-on-skrr-click')
    const count = el.getAttribute('data-on-skrr-click-mto')
    const url = el.getAttribute('data-on-skrr-click-url')
    if (count == 'false' && url) {

      let formData = {
        'items': [
          {
            'id': elId,
            'quantity': 1
          },
        ]
      };

      console.log(formData)
      
      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
      .then(response => {
        setTimeout(() => {
          T4SThemeSP.Cart.getToFetch();
        }, 200)
        setTimeout(() => {
          const el = document.querySelector('.t4s-site-nav__cart a')
          if (!el) return
          el.dispatchEvent(new MouseEvent('click', { bubbles: true }))
        }, 200)
        return response.json();
      })
      .catch((error) => {
        console.error('Error:', error);
      });
    } else {
      window.location.href = url
    }
  })
})


document.addEventListener('click', e => {
  const input = e.target.closest('[data-search]')
  if (!input) return

  if (window.innerWidth < 1000) {
    const target = document.createElement('input')
    usf.utils.loadAndShowInstantSearch(target, true)

    const closeBtn = document.querySelector('.t4s-drawer[data-predictive-search] .t4s-drawer__close')
    if (closeBtn) closeBtn.click()
  }
})

function card_8_discount() {
  setTimeout(() => {
    document.querySelectorAll('.card_8_discount_price').forEach(el => {
      const next = el.nextElementSibling
      if (next && next.classList.contains('t4s-product-price')) {
        const hasIns = next.querySelector('ins')
        const hasDel = next.querySelector('del')
        if (hasIns && hasDel) {
          // Strip all non-numeric characters except dot and comma
          const insText = hasIns.textContent.replace(/[^\d.,]/g, '')
          const delText = hasDel.textContent.replace(/[^\d.,]/g, '')

          // Remove commas used as thousand separators and ensure proper decimal parsing
          const insValue = parseFloat(insText.replace(/,/g, ''))
          const delValue = parseFloat(delText.replace(/,/g, ''))

          if (!isNaN(insValue) && !isNaN(delValue) && delValue > insValue) {
            const diff = Math.round((delValue - insValue) * 100) / 100
            el.innerHTML = `<span class="t4s-badge-price"><span>Économisez</span> $${diff.toFixed(2)}</span>`

            setTimeout(() => {
              if(el.querySelector('.hidden')) {
                el.querySelector('.hidden').classList.remove('hidden')
              }
            }, 100)
          }
        }
      }
    })
  }, 100)
}

document.addEventListener('DOMContentLoaded', () => {
  usf.event.add('init', function() {
    card_8_discount()
    setTimeout(() => {
      card_8_discount()
    }, 300)
  })

  usf.event.add('sr_updated', function(){
    card_8_discount()
    setTimeout(() => {
      card_8_discount()
    }, 300)
  });

  usf.event.add('rerender', function(){
    card_8_discount()
    setTimeout(() => {
      card_8_discount()
    }, 300)
  });
})

// Remove /en from mailtol links
function fixMailtoLinks() {
  document.querySelectorAll('a[href^="mailto:"]').forEach(link => {
    const href = link.getAttribute('href')
    if (href && href.endsWith('/en')) {
      link.setAttribute('href', href.slice(0, -3))
    }
  })
}
fixMailtoLinks()
setInterval(fixMailtoLinks, 2000)

// Promotion - Promo XY - AddtoCart Click
document.addEventListener('click', e => {
  const target = e.target.closest('[data-promo_xy_popup_atc]')
  if (!target) return

  const currentWindow = document.querySelector('[data-product-cart-quickview-content]')
  const allSelectedVariants = currentWindow.querySelectorAll('[data-selected-variant]')
  
  const currentProduct = allSelectedVariants[0].getAttribute('data-selected-variant')
  const selectedProduct = allSelectedVariants[1].getAttribute('data-selected-variant')

  addPromotionToCart (selectedProduct, currentProduct, target)
})

function addPromotionToCart (current, original, button) {
  let formData = {
    'items': [
      {
        'id': current,
        'quantity': 1
      },
      {
        'id': original,
        'quantity': 1
      },
    ]
  };

  button.style.opacity = "0.5"
  button.style.pointerEvents = "none"
  
  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
  .then(response => {
    document.querySelector('[data-product-cart-quickview-modal-close]').click()
    T4SThemeSP.Cart.getToFetch();
    setTimeout(() => {
      document.querySelector(".t4s-site-nav__cart a").click()
    }, 700)

    button.style.opacity = "1"
    button.style.pointerEvents = "all"

    return response.json();
  })
  .catch((error) => {
    console.error('Error:', error);

    button.style.opacity = "1"
    button.style.pointerEvents = "all"
  });
}

// Promotion - Promo XY - Product Click

const parsePriceEl = el => {
  if (!el) return null

  const mainProductPrice = document.querySelector('[data-product-cart-quickview-content] .offer-xy-popup-product [style="display: block;"] [data-price]')
  const mainProductPriceCompare = document.querySelector('[data-product-cart-quickview-content] .offer-xy-popup-product [style="display: block;"] [data-compare]')

  const rawMain = mainProductPrice.textContent.trim().replace(/[^0-9.]/g, '')
  const numMain = parseFloat(rawMain)
  const raw = document.querySelector('[data-product-cart-quickview-content] .offer-xy-popup-lower_portion .buyCard.active').querySelector('[data-price]').textContent.trim().replace(/[^0-9.]/g, '')
  const num = parseFloat(raw)

  let numMainCompare = numMain
  if(mainProductPriceCompare) {
    const rawMainCompare = mainProductPriceCompare.textContent.trim().replace(/[^0-9.]/g, '')
    numMainCompare = parseFloat(rawMainCompare)
  }
  const rawCompare = document.querySelector('[data-product-cart-quickview-content] .offer-xy-popup-lower_portion .buyCard.active').querySelector('[data-compare]').textContent.trim().replace(/[^0-9.]/g, '')
  const numCompare = parseFloat(rawCompare)

  const finalPrice = num + numMain
  const finalComparePrice = numCompare + numMainCompare

  document.querySelector('[data-product-cart-quickview-content] [data-price-final]').innerHTML = `$${finalPrice.toLocaleString('en-US', {minimumFractionDigits: 0, maximumFractionDigits: 2})}`
  document.querySelector('[data-product-cart-quickview-content] [data-compare-final]').innerHTML = `$${finalComparePrice.toLocaleString('en-US', {minimumFractionDigits: 0, maximumFractionDigits: 2})}`
}

document.addEventListener('click', e => {
  const target = e.target.closest('[data-promotion-buy-card-offer]')
  if (!target) return

  const track = target.closest('.splide__track')
  if (!track) return

  track.querySelectorAll('[data-promotion-buy-card-offer].active')
    .forEach(el => el.classList.remove('active'))

  target.classList.add('active')

  const activeBtn = target.querySelector('.variant-thumb-btn.is-active')
  if (!activeBtn) return

  const vid = activeBtn.dataset.variantId || activeBtn.getAttribute('data-variant-id') || ''
  const holder = target.closest('[data-selected-variant]') || track.closest('[data-selected-variant]')
  if (holder) holder.setAttribute('data-selected-variant', vid)

  const priceEl = target
  const num = parsePriceEl(priceEl)
})

// Variant Check

document.addEventListener('click', e => {
  const colorBtn = e.target.closest('.variant-thumb-btn')
  if (colorBtn) {
    const container = colorBtn.closest('.variant-new-neuf-buttons')
    if (!container) return

    container.querySelectorAll('.variant-thumb-btn').forEach(b => b.classList.remove('is-active'))
    colorBtn.classList.add('is-active')

    const root = colorBtn.closest('[data-selected-variant]')
    const rootLimit = colorBtn.closest('[data-limit]')
    if (root) {
      const vid = colorBtn.dataset.variantId || colorBtn.getAttribute('data-variant-id') || ''
      root.setAttribute('data-selected-variant', vid)

      const priceEl = colorBtn

      const panels = rootLimit.querySelectorAll('[data-variant-selected-choice]')
      panels.forEach(p => {
        const key = p.getAttribute('data-variant-selected-choice') || p.id || ''
        p.style.display = key === vid ? 'block' : 'none'
      })

      const label = container.previousElementSibling
      if (label) {
        const optionValue = colorBtn.getAttribute('title') || colorBtn.getAttribute('aria-label')
        label.querySelector('.color_title').textContent = optionValue
      }

      setTimeout(() => {
        const num = parsePriceEl(rootLimit)
      }, 100)
    }
  }

  const grandeurBtn = e.target.closest('.grandeur-btn')
  if (grandeurBtn) {
    const container = grandeurBtn.closest('.grandeur-buttons')
    if (!container) return

    container.querySelectorAll('.grandeur-btn').forEach(b => b.setAttribute('aria-pressed', 'false'))
    grandeurBtn.setAttribute('aria-pressed', 'true')

    const label = container.previousElementSibling
    if (label) {
      const optionValue = grandeurBtn.textContent.trim()
      label.textContent = 'Grandeur: ' + optionValue
    }
  }
})




// Promotion - Promo XY - Splide Activation
window.initPromotionSplides = function(root, clicked = false){
  var base = root || document
  var nodes = base.querySelectorAll('.splide[data-promo-splide]')

  nodes.forEach(function(el){
    if (el._splide) {
      el._splide.destroy(true)
      el._splide = null
      delete el.dataset.mounted
    }

    let inst = new Splide(el, {
      drag: true,
      pagination: true,
      perPage: 3,
      gap: 20,
      breakpoints: {
        1000: { perPage: 1 }
      }
    })
    inst.mount()
    el.dataset.mounted = '1'
    el._splide = inst
  })

  if(clicked && nodes[0]){
    var btn = nodes[0].querySelector('.buyCard')
    if (btn) {
      btn.click()
    }
  }
}

document.addEventListener('DOMContentLoaded', function(){
  window.initPromotionSplides(document)
})


var mo = new MutationObserver(function(muts){
  muts.forEach(function(m){
    m.addedNodes.forEach(function(n){
      if (n.nodeType !== 1) return
      if (n.matches && n.matches('.splide[data-promo-splide]')) {
        window.initPromotionSplides(n.parentNode || document, true)
      } else if (n.querySelector) {
        var found = n.querySelector('.splide[data-promo-splide]')
        if (found) {
          window.initPromotionSplides(n, true)
        }
      }
    })
  })
})

mo.observe(document.documentElement, { childList: true, subtree: true })
// Promotion - Promo XY - Splide Activation END


// Product Card Promotion Card

const urlParams = new URLSearchParams(window.location.search)

if (urlParams.get('iframe') === 'true') {
  const style = document.createElement('style')
  style.textContent = `
    #shopify-section-announcement-bar,
    #shopify-section-top-bar,
    #shopify-section-header-categories-menu,
    #shopify-section-footer,
    #t4s-footer,
    [role="dialog"]
    {
      display: none !important;
    }
  `
  document.head.appendChild(style)
}

const armSet = new WeakSet()

document.addEventListener('pointerdown', e => {
  const btn = e.target.closest('[data-open-popup-promotion], [data-open-popup-page], [data-open-popup-rich-text]')
  if (btn) armSet.add(btn)
})

function openOnClick(selectorButton, selectorContent) {
  document.addEventListener('click', e => {
    const btn = e.target.closest(selectorButton)
    if (!btn || !armSet.has(btn)) return
    const contentEl = btn.querySelector(selectorContent)
    const container = document.querySelector('[data-product-cart-quickview-content]')
    const wrapper = document.querySelector('.product-cart-quickview-wrapper')
    if (contentEl && container && wrapper) {
      container.innerHTML = contentEl.innerHTML
      wrapper.classList.add('active')
      window.initPromotionSplides(container)
    }
    armSet.delete(btn)
  })
}

openOnClick('[data-open-popup-rich-text]', '[data-open-popup-rich-text-content]')
openOnClick('[data-open-popup-page]', '[data-open-popup-page-content]')
openOnClick('[data-open-popup-promotion]', '[data-open-popup-promotion-content]')



document.addEventListener('click', e => {
  if (e.target.closest('[data-product-cart-quickview-modal-close]')) {
    const wrapper = document.querySelector('.product-cart-quickview-wrapper')
    if (wrapper) wrapper.classList.remove('active')
  } else if (e.target.classList.contains('product-cart-quickview-wrapper')) {
    e.target.classList.remove('active')
  }
})
// Product Card Promotion Card END


document.addEventListener('click', e => {
  const toggleBtn = e.target.closest('[data-show-card-promotion-offer-wrap-other]')
  if (!toggleBtn) return

  const card = toggleBtn.parentElement.querySelector('.card-promotion-offer-wrap-other')
  const arrow = toggleBtn.querySelector('.arrow')

  if (!card || !arrow) return

  const isActive = arrow.classList.contains('active')

  if (isActive) {
    card.style.height = ''
    arrow.classList.remove('active')
  } else {
    const children = Array.from(card.children)
    const childrenHeight = children.reduce((total, child) => total + child.offsetHeight, 0)
    const totalGap = (children.length - 1) * 10 // 10px gap between each
    card.style.height = (childrenHeight + totalGap) + 'px'
    arrow.classList.add('active')
  }
})

document.addEventListener('click', (e) => {
  const toggle = e.target.closest('[data-product-card-eight-show-more]')
  if (!toggle) return

  const content = toggle.parentElement.querySelector('[data-product-card-eight-show-more-content]')
  if (!content) return

  if (content.style.maxHeight) {
    content.style.maxHeight = null
    setTimeout(() => {
      content.style.display = 'none'
    }, 130)
  } else {
    content.style.display = 'block'
    content.style.maxHeight = content.scrollHeight + 'px'
  }
})

usf.event.add('rerender', function(){
  setTimeout(() => {
    window.dispatchEvent(new Event('resize'));
  }, 200)
  setTimeout(() => {
    window.dispatchEvent(new Event('resize'));
  }, 500)
});

const swatchItemsforInventoryChange = document.querySelectorAll('.t4s-swatch__item');

swatchItemsforInventoryChange.forEach(item => {
  item.addEventListener('click', function(event) {
    setTimeout(() => {
      const visibleAvailabilityItem = Array.from(document.querySelectorAll('.inventory_message_wrapper [data-availability].product-stock-message')).find(
        el => window.getComputedStyle(el).display !== 'none'
      )
      
      if (visibleAvailabilityItem) {
        const availability = visibleAvailabilityItem.getAttribute('data-availability')
        document.getElementById("data-availability-property").value = availability
      }
    }, 100)
  })
})


window.addEventListener('load', function() {

function createIframeWithoutDocumentWrite(containerId) {
  if (typeof __st !== "undefined" && __st.cid != "" && __st.cid) {
    return
  }

  if (typeof window._os_fm === "undefined") window._os_fm = 1
  else window._os_fm++

  const _slc = typeof Shopify !== "undefined" && typeof Shopify.locale !== "undefined" ? "&lc=" + Shopify.locale : "&lx=lx"
  const _os_parent_location = encodeURIComponent(window.location.href)
  const _os_parent_root = window.Shopify && window.Shopify.routes ? encodeURIComponent(window.Shopify.routes.root) : "/"

  const insertOnce = () => {
    const loginArea = document.getElementById(containerId)
    if (!loginArea) return false
    if (loginArea.querySelector('iframe[id^="osiframe_"]')) return true
    const src = "https://open-signin.okasconcepts.com/loginform?site=fillion-electonique.myshopify.com&microtimestamp=" + window._os_fm + "&timestamp=17370571591737394458&ua=2&parenturl=" + _os_parent_location + "&parentroot=" + _os_parent_root + _slc
    const iframeHTML = "<iframe src='" + src + "' width='100%' height='100%' style='border:0px;padding-top:0px;padding-bottom:5px;height:100%;max-width:100%;min-height:47px;max-height:50px;' scrolling=no id='osiframe_" + window._os_fm + "'></iframe>"
    loginArea.innerHTML = iframeHTML
    return true
  }

  if (!window._os_iframe_msg_listener) {
    const _os_parent_redirect_map = {
      '/': _os_parent_root,
      '/account': _os_parent_root + "/account",
      '/pages/welcome': _os_parent_root + "/pages/welcome"
    }
    let _os_parent_redirect = 'CALL_PAGE'
    if (_os_parent_redirect in _os_parent_redirect_map) _os_parent_redirect = _os_parent_redirect_map[_os_parent_redirect]

    const iframeResponse123 = function (e) {
      if (e && typeof e.preventDefault === 'function') e.preventDefault()
      if (e.origin + '/' == "https://open-signin.okasconcepts.com/") {
        if (typeof e.data === "string") {
          const key = e.data.split(':')[0]
          const value = e.data.split(':')[1]
          if (key && key.startsWith("height_")) {
            const frameid = key.slice(7)
            const el = document.getElementById('osiframe_' + frameid)
            if (el && value) el.style.height = value + "px"
          }
        }
      }
    }
    window.addEventListener ? window.addEventListener('message', iframeResponse123, false) : window.attachEvent("onmessage", iframeResponse123)
    window._os_iframe_msg_listener = true
  }

  const tryForever = () => {
    let placed = insertOnce()
    if (placed) return
    let attempts = 0
    const maxAttempts = 200
    const loop = () => {
      if (insertOnce()) return
      attempts++
      if (attempts < maxAttempts) setTimeout(loop, Math.min(2000, 100 + attempts * 50))
    }
    loop()
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tryForever, { once: true })
  } else {
    tryForever()
  }
}

createIframeWithoutDocumentWrite('login_area_for_buttons')
createIframeWithoutDocumentWrite('create_acc_area_for_buttons')


  
  var _learnq = window._learnq || [];
  function addedToCart() {
   fetch(`${window.location.origin}/cart.js`)
   .then(res => res.clone().json().then(data => {
    var cart = {
      total_price: data.total_price/100,
      $value: data.total_price/100,
      total_discount: data.total_discount,
      original_total_price: data.original_total_price/100,
      items: data.items
    }
    if (klAjax) {
       _learnq.push(['track', 'Added to Cart', cart]);
       klAjax = false;
      }
   }))
  };
  
  (function (ns, fetch) {
    ns.fetch = function() {
      const response = fetch.apply(this, arguments);
      response.then(res => {
        if (`${window.location.origin}/cart/add.js`
          .includes(res.url) && res.url !== '') {
              addedToCart()
        }
      });
      return response
     }
  }(window, window.fetch));
  
  var klAjax = true;
  
  var atcButtons = document.querySelectorAll("form[action*='/cart/add'] button[type='submit']");
  
  for (var i = 0; i < atcButtons.length; i++) { 
    atcButtons[i].addEventListener("click", function() {
      if (klAjax) {
        _learnq.push(['track', 'Added to Cart', item]);
        klAjax = false;
      }
    })
  }
  
});

// Select the Same Condition on other Variants

function addClickEventToUnavailableSwatchItems() {
  const unavailableSwatchItems = document.querySelectorAll('[data-swatch-item].is--unavailable');
  const isActiveUSI = document.querySelector('[data-change-to-available-variant]')
  unavailableSwatchItems.forEach(item => {
    if (!item.hasClickListener) {
      item.addEventListener('click', function() {
        if(isActiveUSI.getAttribute('data-change-to-available-variant') != 'false')
        {
          if (!this.classList.contains('is--unavailable')) {
            return;
          }
          
          const initialInnerHTML = this.innerHTML;
          // console.log(initialInnerHTML)
          
          const firstSwatches = document.querySelector('[data-swatch-list]');
          const firstSwatchesButtons = firstSwatches.querySelectorAll('[data-swatch-item]');
          
          let swatchGridClicked = false;
  
          outerLoop:
          for (let swatchGrid of firstSwatchesButtons) {
            swatchGrid.click();
            
            const allSwatchItems = document.querySelectorAll('[data-swatch-item]');
  
            for (let swatchItem of allSwatchItems) {
              if (swatchItem.innerHTML === initialInnerHTML ) {
                if(!swatchItem.classList.contains('is--unavailable')) {
                  swatchGrid.click();
                  swatchGridClicked = true;
                  break outerLoop;
                }
              }
            }
          }
  
          if (!swatchGridClicked) {
            firstSwatchesButtons[0].click()
            console.log("No swatchGrid to click was found.");
          }
        }
      });
      item.hasClickListener = true;
    }
  });
}

const observer = new MutationObserver(addClickEventToUnavailableSwatchItems);

observer.observe(document.body, { childList: true, subtree: true });

addClickEventToUnavailableSwatchItems();




// Select the Same Condition on other Variants END


const swatchItemsforFBTChange = document.querySelectorAll('.t4s-swatch__item');

// FBT Product option change on color change
swatchItemsforFBTChange.forEach(item => {
  item.addEventListener('click', function(event) {
      let value = item.getAttribute('data-value')

      if (value)
      {
        document.querySelectorAll('[data-fbt-choices]').forEach(select => {
          let option = Array.from(select.options).find(opt => opt.text.includes(value));
          if (option) {
            // console.log('Found option that contains value:', option.text);
            select.value = option.value;
            option.selected = true;
            handleChange(select);
          }
        });
      }
  })
})

// FBT Product option change on color change END

// Hide NEUF Option if it's only one

function hudeButtons() {
  let currentSwatches = []
  swatchItemsforFBTChange.forEach(select => {
    let name = select.getAttribute('data-swatch-item-option-name')

    if(name == 'Condition')
    {
      const selected = select.closest('[data-swatch-option-name="Condition"]')
        ?.querySelector('.is--selected')
      const otherSwatches = [...swatchItemsforFBTChange]
          .filter(el => !el.classList.contains('is--selected'))

      let selectedValue
      
      if (selected && selected.getAttribute('data-value') !== 'NEUF') {
        selectedValue = 'other'
      } else {
        selectedValue = 'new'
      }

      if(selectedValue == 'other') {
        const allOtherSoldout = otherSwatches.every(el => el.classList.contains('is--soldout'))

        if (allOtherSoldout) {
          otherSwatches.forEach((el) => {
            el.style.display = 'none'
          })
        } else {
          otherSwatches.forEach((el) => {
            if(el.getAttribute('data-value') != 'PROMOTION') {
            console.log(el)
              el.style.display = 'inline-block' 
            }
          })
        }
      }
      
      let isshow = select.getAttribute('data-swatch-item-option-isshow')
      if(isshow == 'true')
      {
        const dataSwatchOptionName = document.querySelector('[data-swatch-option-name="Condition"]');
        dataSwatchOptionName.style.display = 'inline-block';
      } else {
        const dataSwatchOptionName = document.querySelector('[data-swatch-option-name="Condition"]');
        dataSwatchOptionName.style.display = 'none';
      }
      
      // currentSwatches.push(select)
      // let availableSwatchesCount = 0;
      // currentSwatches.forEach(button => {
      //     if (!button.classList.contains('is--unavailable') && !button.classList.contains('is--soldout')) {
      //         availableSwatchesCount++;
      //     }
      // });
      // // console.log(currentSwatches[0].getAttribute('data-value'))
      // if (availableSwatchesCount === 1 && (currentSwatches[0].getAttribute('data-value') === 'NEUF' || currentSwatches[0].getAttribute('data-value') === 'NEW')) {
      //   // console.log('suh')
      //   const dataSwatchOptionName = document.querySelector('[data-swatch-option-name="Condition"]');
      //   dataSwatchOptionName.style.display = 'none';
      // } else {
      //   const dataSwatchOptionName = document.querySelector('[data-swatch-option-name="Condition"]');
      //   dataSwatchOptionName.style.display = 'inline-block';
      // }
    }
  })
}
setTimeout(() => {
  hudeButtons()
}, 2750)

swatchItemsforFBTChange.forEach(item => {
  item.addEventListener('click', function(event) {
    let value = item.getAttribute('data-value')

    setTimeout(() => {
      if (value)
      {
        hudeButtons()
      }
    }, 100)
  })
})

// END Hide NEUF Option if it's only one

// FBT Product image change

document.addEventListener('DOMContentLoaded', function() {
    document.addEventListener('click', function(event) {
        var selectElement = event.target.closest('select[data-fbt-choices]');
        if (selectElement) {
            handleChange(selectElement);
        }
    });
});

function handleChange(selectElement) {
    var selectedValue = selectElement.value;
    var closestImgContainer = selectElement.closest('.t4s-fbt__img');

    if (closestImgContainer) {
        var allFbtImages = closestImgContainer.querySelectorAll('[data-product-fbt-image]');

        allFbtImages.forEach(function(imgElement) {
            imgElement.style.display = 'none';
        });

        var matchingElement = closestImgContainer.querySelector('[data-product-fbt-image="' + selectedValue + '"]');
        if (matchingElement) {
            matchingElement.style.display = 'block';
        }
    }
}



// FBT Product Image Changed END



// Line Item Property

// First Version, switched to only cart

// const swatchItems = document.querySelectorAll('.t4s-swatch__item');

// swatchItems.forEach(item => {
//   item.addEventListener('click', function(event) {
//     setTimeout(() => {
//       document.querySelectorAll('[data-availability]').forEach(item => {
//         if (window.getComputedStyle(item).display !== 'none') {
//             const availability = item.getAttribute('data-availability');
            
//             const inputElement = document.querySelector('#product_variant_availability');
//             if (inputElement) {
//               inputElement.value = availability;
//             }
//         }
//       });
//     }, 100)
//   });
// });

// Line Item Property END

jQuery_T4NT(document).ready(function($) {
	const selectors = {
        enableStickyMedia: ".js-enable-sticky-media",
		subMenuNav: ".js-sub-menu-nav",
        tab: ".js-sub-menu-nav-wrap",
		header: ".t4s-section-header",
		anchorLink: "[data-anchor-link]",
		tabItem: ".js-sub-menu-nav-wrap [data-t4s-tab-item]",
		tabContent: ".js-sub-menu-nav-wrap [data-t4s-tab-content]"
	};

	const classes = {
        mediaContainerStickyHeader: "t4s-product__media-container--sticky-header",
		tabHide: "tab-hide",
		headerHidden: "shopify-section-header-hidden",
		headerSticky: "shopify-section-header-sticky",
		active: "t4s-active"
	};

    const mediaQuery = window.matchMedia('(min-width: 768px)');

    function initEnableProductStickyMedia() {
        const mediaQuery = window.matchMedia('(min-width: 768px)');

        if (!mediaQuery.matches) return null;

        const enableStickyMedia = document.querySelector(selectors.enableStickyMedia);

        if (!enableStickyMedia) return null;

        window.addEventListener("scroll", () => {
            const { isHeaderHidden, isHeaderSticky, headerOffsetHeight } = getHeaderInfo();

            if (!isHeaderHidden && isHeaderSticky) {
                enableStickyMedia.style.top = `${headerOffsetHeight}px`;
            } else {
                enableStickyMedia.removeAttribute('style');
            }
        });
    }

	function initSubMenuNavPosition() {
		const subMenuNav = document.querySelector(selectors.subMenuNav);
		const subMenuNavWrap = document.querySelector(selectors.tab);

		if (!subMenuNav) return null;

		let initialSubMenuNavPosition = subMenuNav.offsetTop;

		if (window.scrollY > initialSubMenuNavPosition) {
			subMenuNav.classList.add("sticky");
			subMenuNav.classList.remove("sticky-header");
		}

		function checkSubMenuPosition() {
			const { isHeaderHidden } = getHeaderInfo();

    		let currentSubMenuNavPosition = subMenuNav.offsetTop;

            if(currentSubMenuNavPosition > 0)
            {
              initialSubMenuNavPosition = currentSubMenuNavPosition
            }

			if (window.scrollY < initialSubMenuNavPosition) {
				subMenuNav.classList.remove("sticky");
				subMenuNav.classList.remove("sticky-header");
                subMenuNavWrap.style.marginTop = `0px`;

				return null;
			}

			if (isHeaderHidden) {
				subMenuNav.classList.add("sticky");
				subMenuNav.classList.remove("sticky-header");
			} else {

                subMenuNavWrap.style.marginTop = `${subMenuNav.offsetHeight}px`;
              
				subMenuNav.classList.add("sticky-header");
				subMenuNav.classList.remove("sticky");
			}
		}

		setTimeout(() => {
			window.addEventListener("scroll", checkSubMenuPosition);
		}, 2000);
	}

	function initSubMenuNavAnchors() {
		const subMenuNav = document.querySelector(selectors.subMenuNav);

		if (!subMenuNav) return null;

		const anchorLinks = document.querySelectorAll(selectors.anchorLink);
		const tabLinks = document.querySelectorAll('[data-t4s-tab-item]');


		if (!anchorLinks.length) return null;

        let firstLink = ''
        let secondaryLink = ''

		setTimeout(() => {
			tabLinks.forEach((link) => {

                if(( link.innerHTML.includes('More information') || link.innerHTML.includes('Plus information') ) && link.classList.contains('t4s-tab__title') ) {
                  secondaryLink = link
                }
              
            })
			tabLinks.forEach((link) => {
				const targetId = link.getAttribute('href').substring(1);
				const targetElement = document.getElementById(targetId);
        
                if(link.innerHTML.includes('Description'))
                {
                  firstLink = link
                }

                if((link.innerHTML.includes('More information') || link.innerHTML.includes('Plus information')) && !link.classList.contains('t4s-tab__title')) {

                  let wasClicked = false
                  link.addEventListener("click", () => {
                    if(!wasClicked) {
                      setTimeout(() => {
                        wasClicked = true
                        link.click()
                      }, 500)
                    }
                  })
                  
                  let hasHeight = false;

                if(targetElement) {
                  let flixmedia = targetElement.querySelector('.metakey-flixmedia')
                  let flixmediawp = targetElement.querySelector('.metakey-flixmediawp')

                  // For More info that is not iframe. Idea is to look if content inside #flix-minisite or #flix-inpage exists.
                  if (flixmedia) {
                    let isThereChild = false
                    for(let ik = 0; ik < 10; ik ++) {
                      setTimeout(() => {
                        const targetElementMini = targetElement.querySelector('#flix-minisite');
                    
                        for (let i = 0; i < targetElementMini?.children.length; i++) {
                            const child = targetElementMini.children[i];
                              // console.log(child.tagName.toLowerCase())
                            if (child.tagName.toLowerCase() !== 'script') {
                              console.log('there is a mini child')
                              link.classList.remove(classes.tabHide);
                              secondaryLink.classList.remove(classes.tabHide);
                              if(!isThereChild) {
                                flixmedia.querySelector('#flix-inpage').closest('.t4s-tab-content').style.display = 'none'
                              }
                              isThereChild = true
                              window.dispatchEvent(new Event("resize"));
                              break;
                            } else {
                              console.log('there is no mini child')
                              isThereChild = false
                              link.classList.add(classes.tabHide);
                              secondaryLink.classList.add(classes.tabHide);
                              flixmedia.querySelector('#flix-inpage').closest('.t4s-tab-content').style.display = 'none'
                              window.dispatchEvent(new Event("resize"));
                            }
                        }

                        if (targetElementMini?.children.length == 0) {
                          const targetElementInPage = targetElement.querySelector('#flix-inpage');
                          for (let i = 0; i < targetElementInPage?.children.length; i++) {
                            const child2 = targetElementInPage.children[i];
                            if (child2.tagName.toLowerCase() !== 'script') {
                              console.log('there is an inpage child')
                              link.classList.remove(classes.tabHide);
                              secondaryLink.classList.remove(classes.tabHide);
                              if(!isThereChild) {
                                flixmedia.querySelector('#flix-inpage').closest('.t4s-tab-content').style.display = 'none'
                              }
                              isThereChild = true
                              window.dispatchEvent(new Event("resize"));
                              break;
                            } else {
                              if (!isThereChild)
                              {
                                console.log('there is no in page child')
                                isThereChild = false
                                link.classList.add(classes.tabHide);
                                secondaryLink.classList.add(classes.tabHide);
                                flixmedia.querySelector('#flix-inpage').closest('.t4s-tab-content').style.display = 'none'
                                window.dispatchEvent(new Event("resize"));
                              }
                            }
                          }
                        }
                        window.dispatchEvent(new Event("resize"));
                      }, ik * 1000) 
                    }
                  }

                  if (flixmediawp) {
                  } else {
        			      window.dispatchEvent(new Event("resize"));
                  }
                  
                  if (!hasHeight) {
                      link.classList.add(classes.tabHide);
                      // secondaryLink.classList.add(classes.tabHide);
                      window.dispatchEvent(new Event("resize"));
                  }
                }
              }
			});
			anchorLinks.forEach((link) => {
				const targetId = link.getAttribute('href').substring(1);
				const targetElement = document.getElementById(targetId);

				// if (!targetElement) {
				// 	link.classList.add(classes.tabHide);
				// }

                function waitForElement(elementId, callBack){
                  window.setTimeout(function(){
                    var element = document.getElementById(elementId);
                    if(element){
                      callBack(elementId, element);
                      // console.log('Found')
                      link.classList.remove(classes.tabHide);
                      window.dispatchEvent(new Event("resize"));
                    }else{
                      link.classList.add(classes.tabHide);
                      // console.log('Not Found')
                      waitForElement(elementId, callBack);
                      window.dispatchEvent(new Event("resize"));
                    }
                  },500)
                }

                waitForElement(targetId,function(){
                  console.log("done");
                });
			});

			window.dispatchEvent(new Event("resize"));
		}, 2500);
      

		document.addEventListener("click", (event) => {
			const anchorLink = event.target.closest(selectors.anchorLink);

			if (!anchorLink) return null;

			event.preventDefault();

			const targetId = anchorLink.getAttribute('href').substring(1);
			const targetElement = document.getElementById(targetId);
			const subMenuNavOffsetHeight = subMenuNav.offsetHeight;


			if (targetElement) {
				const { headerOffsetHeight } = getHeaderInfo();

				let targetOffset = targetElement.offsetTop - subMenuNavOffsetHeight;

				// if (window.scrollY > targetOffset) {
				// 	targetOffset = targetElement.offsetTop - subMenuNavOffsetHeight - headerOffsetHeight;
				// } else if ((subMenuNav.classList.contains("sticky") || subMenuNav.classList.contains("sticky-header")) && window.scrollY < targetOffset) {
				// 	targetOffset = targetElement.offsetTop - subMenuNavOffsetHeight;
				// } else if (window.scrollY === targetElement.offsetTop) {
				// 	return null;
				// } else if (window.scrollY < targetOffset) {
				// 	targetOffset = targetElement.offsetTop - subMenuNavOffsetHeight - subMenuNavOffsetHeight;
				// }

				window.scrollTo({
					top: targetOffset,
					behavior: 'smooth'
				});
			}
		});
	}

	function initSubMenuNavActiveItems() {
		const subMenuNav = document.querySelector(selectors.subMenuNav);

		if (!subMenuNav) return null;

		const anchorLinks = document.querySelectorAll(selectors.anchorLink);

		if (!anchorLinks.length) return null;

		let anchorSectionsPosition = getAnchorSectionsPosition();

        document.addEventListener("click", (event) => {
			const target = event.target.closest(selectors.tabItem);

			if (!target) return null;

			anchorSectionsPosition = getAnchorSectionsPosition();
		});

		document.addEventListener("scroll", scrollHandlerSubMenuActiveItems);


		function scrollHandlerSubMenuActiveItems() {
			const { isHeaderSticky, isHeaderHidden, headerOffsetHeight } = getHeaderInfo();
			let currentPosition = null;

			if (isHeaderHidden) {
				currentPosition = window.scrollY + subMenuNav.offsetHeight + 63;
			} else if (isHeaderSticky) {
				currentPosition = window.scrollY + subMenuNav.offsetHeight + headerOffsetHeight + 63;
			} else {
              currentPosition = window.scrollY + subMenuNav.offsetHeight;
            }

			let closestSection = null;

			anchorSectionsPosition.forEach((section) => {
              
                let targetOffetOnTop = section.targetOffsetTop - (window.innerHeight - 300)
              
				if (currentPosition >= targetOffetOnTop) {
					closestSection = section;
				}
			});

			anchorLinks.forEach((link) => {
				link.classList.remove(classes.active);
			});

			if (closestSection) {
				closestSection.link.classList.add(classes.active);

				const tabItems = document.querySelectorAll(selectors.tabItem);

				if (!tabItems.length) return null;

				tabItems.forEach((tab) => {
					tab.classList.remove(classes.active);
				});
			} else {
				const tabItems = document.querySelectorAll(selectors.tabItem);

				if (!tabItems.length) return null;

				const tabContents = document.querySelectorAll(selectors.tabContent);

				if (!tabContents.length) return null;

				let isActiveTab = false;

				tabContents.forEach(tabContent => {
					if (tabContent.classList.contains(classes.active)) {
						isActiveTab = true;

						tabItems.forEach(tabItem => {
							const id = tabItem.getAttribute('href').substring(1);

							if (id === tabContent.id) {
								tabItem.classList.add(classes.active);
							}
						});
					}
				});

				if (!isActiveTab) {
					tabItems[0].classList.add(classes.active);
				}
			}
		}

		scrollHandlerSubMenuActiveItems();
	}

	function getAnchorSectionsPosition() {
		const anchorSectionsPosition = [];

		const anchorLinks = document.querySelectorAll(selectors.anchorLink);

		if (!anchorLinks.length) return null;

        for(var i = 0; i < 10; i++)
        {
  
    		setTimeout(() => {
    			anchorLinks.forEach((link) => {
    				const targetId = link.getAttribute('href');
    				const targetElement = document.getElementById(targetId.substring(1));
    
    
    				if (targetElement) {
    					anchorSectionsPosition.push({
    						link,
    						targetOffsetTop: targetElement.offsetTop
    					});
    				}
    			});
    		}, i * 1000);
            
        }

		return anchorSectionsPosition;
	}

	function getHeaderInfo() {
		const header = document.querySelector(selectors.header);

		if (!header) return null;

		return {
			isHeaderHidden: header.classList.contains(classes.headerHidden),
			isHeaderSticky: header.classList.contains(classes.headerSticky),
			headerOffsetHeight: header.offsetHeight
		};
	}

    $(document).on("variant:changed", function (evt) {
        showComboSection();
    });

    function showComboSection() {
        const url = new URL(window.location.href);
        const variant = url.searchParams.get("variant");

        if (!variant) return null;

        const comboSection = $('[data-combo-toggle]');

        if (!comboSection) return null;

        comboSection.hide(0);
        $('[data-combo-toggle="' + variant + '"]').show(0);
    }

    showComboSection();

    mediaQuery.addEventListener("change", initEnableProductStickyMedia);

    initEnableProductStickyMedia();

	initSubMenuNavActiveItems();

	initSubMenuNavAnchors();

	initSubMenuNavPosition();
});